import {useMemo, useState} from "react";
import {Stack, Typography} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import {appStyles} from "../../../../AppStyles.ts";
import {StyledInputBase, StyledSearch, StyledSearchIconWrapper} from "../../../AppStyledComponents.tsx";
import type {ProvenanceLink} from "../../../../sdo/ProvenanceLink.ts";
import ProvenanceCard from "./provenance/ProvenanceCard.tsx";

// TODO: Replace with API call to load provenance from IntelProfileManager.readProvenance()
function buildTestData(): ProvenanceLink[] {
    return [
        {
            uid: "1",
            sourceType: "MANUAL_ENTRY",
            sourcePath: "https://internal.tr3ad.example/analysts/jdoe/notes/2026-03-15",
            sourceUID: "MAN-2026-03-15-A001",
            details: "Initial analyst entry created during the March 2026 review cycle.",
        },
        {
            uid: "2",
            sourceType: "IMPORT_FEED",
            sourcePath: "https://feeds.partner.example/csv/threat-indicators-2025-041.csv",
            sourceUID: "FEED-CSV-2025-041",
            details: "Imported as part of the partner threat indicator batch ingest.",
        },
        {
            uid: "3",
            sourceType: "API_INGEST",
            sourcePath: "https://api.enrichment.example/v2/geo/lookup",
            sourceUID: "API-GEO-7782",
            details: "Geolocation enrichment applied to base record after IP range match.",
        },
        {
            uid: "4",
            sourceType: "ANALYST_REVIEW",
            sourcePath: "https://internal.tr3ad.example/reviews/case-alpha/r-118",
            sourceUID: "REV-ALPHA-118",
            details: "",
        },
    ];
}

function UXIntelProvenancePanel() {
    const [provenanceLinks] = useState<ProvenanceLink[]>(buildTestData);
    const [filterText, setFilterText] = useState("");

    const filtered = useMemo(() => {
        if (!filterText.trim()) return provenanceLinks;
        const q = filterText.toLowerCase();
        return provenanceLinks.filter((p) => JSON.stringify(p).toLowerCase().includes(q));
    }, [provenanceLinks, filterText]);

    return (
        <Stack sx={appStyles.defaultPanelContainer} direction="column" padding={1} width="100%">
            {/* Title */}
            <Stack direction="row" padding={1} justifyContent="center">
                <Typography sx={appStyles.panelSectionTitle}>Provenance Links</Typography>
            </Stack>

            {/* Filter bar */}
            <Stack direction="row" spacing={1} padding={1} alignItems="center" justifyContent="center" sx={{position: "relative"}}>
                <StyledSearch>
                    <StyledSearchIconWrapper>
                        <SearchIcon sx={{fontSize: 16, color: "#7093a0"}}/>
                    </StyledSearchIconWrapper>
                    <StyledInputBase
                        placeholder="Filter provenance..."
                        value={filterText}
                        onChange={(e) => setFilterText(e.target.value)}
                    />
                </StyledSearch>

                <Typography sx={appStyles.panelFilterCount}>
                    Showing {filtered.length} of {provenanceLinks.length}
                </Typography>
            </Stack>

            {/* Provenance cards list */}
            <Stack direction="column" spacing={1} sx={{...appStyles.defaultPanelCardsWrapper, padding: "8px", alignItems: "stretch"}}>
                {filtered.map((link) => (
                    <ProvenanceCard
                        key={link.uid}
                        provenanceLink={link}
                    />
                ))}
                {filtered.length === 0 && (
                    <Typography sx={{
                        color: "rgba(242, 245, 250, 0.4)",
                        fontSize: "0.80rem",
                        textAlign: "center",
                        padding: "24px",
                    }}>
                        No provenance links match the current filter.
                    </Typography>
                )}
            </Stack>
        </Stack>
    );
}

export default UXIntelProvenancePanel;
